export default defineNuxtPlugin(() => {
  // Defer GSAP off the critical path — load on idle / first interaction.
  if (import.meta.server) return;

  const { loadGSAP } = useGSAP();

  const scheduleLoad = () => {
    void loadGSAP().catch((error) => {
      console.warn("Failed to initialize GSAP in plugin:", error);
    });
  };

  if ("requestIdleCallback" in window) {
    requestIdleCallback(scheduleLoad, { timeout: 4000 });
  } else {
    setTimeout(scheduleLoad, 2000);
  }

  const onFirstInteraction = () => {
    scheduleLoad();
    window.removeEventListener("pointerdown", onFirstInteraction);
    window.removeEventListener("keydown", onFirstInteraction);
    window.removeEventListener("touchstart", onFirstInteraction);
  };
  window.addEventListener("pointerdown", onFirstInteraction, { once: true });
  window.addEventListener("keydown", onFirstInteraction, { once: true });
  window.addEventListener("touchstart", onFirstInteraction, { once: true });
});
